import {JsonPipe} from '@angular/common';
import {AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {FormBuilder, FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { ITeam } from '@teammood/team';
import { distinctUntilChanged, tap } from 'rxjs';

@Component({
    selector: 'multi-team-selector',
    templateUrl: './multi-team-selector.component.html',
    styleUrls: ['./multi-team-selector.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatChipsModule,
    ]
})
export class MultiTeamSelectorComponent implements OnInit {

    @Input() teams: ITeam[];
    @Input() context: 'questionCreaction' | 'taskbook';
    @Output() onTeamSelectionChanged = new EventEmitter();
    
    teamsCtrl = new FormControl([]);

    constructor(){
        this.teamsCtrl.valueChanges.pipe(
            distinctUntilChanged(),
            tap(() => {
                const selectedTeams = this.teamsCtrl.getRawValue();
                this.onTeamSelectionChanged.emit(selectedTeams);
            }),
            takeUntilDestroyed()
        ).subscribe();
    }

    ngOnInit() {
        if(this.teams.length === 1){
            this.teamsCtrl.setValue(this.teams)
        }
        if(this.context === 'taskbook'){
            const teams = [...this.teams]
            this.teamsCtrl.setValue(teams)
        }
    }
  
    onTeamRemoved(team: ITeam) {
        const selectedTeams = this.teamsCtrl.value as ITeam[];
        this.removeFirst(selectedTeams, team);
        this.teamsCtrl.setValue(selectedTeams); // To trigger change detection
        this.onTeamSelectionChanged.emit(selectedTeams)
    }
  
    private removeFirst(array: ITeam[], toRemove: ITeam) {
        const index = array.indexOf(toRemove);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }
}
